import { useContext, useEffect, useRef } from 'react';
import LoadingContext from '../context/loading-context';

export const useLoadingHook = () => {
  const context = useContext(LoadingContext);
  
  if (!context) {
    throw new Error('useLoadingHook must be used within a LoadingProvider');
  }
  
  return context;
};

// Hook that auto-generates a unique ID for the loading source
export const useLoading = () => {
  const { setLoading, isLoading } = useLoadingHook();
  const idRef = useRef<string>(`loading_${Math.random().toString(36).substring(7)}_${Date.now()}`);
  
  useEffect(() => {
    // Cleanup: ensure loading is stopped when component unmounts
    return () => {
      setLoading(idRef.current, false);
    };
  }, [setLoading]);
  
  const setLoadingState = (loading: boolean) => {
    setLoading(idRef.current, loading);
  };
  
  return { isLoading, setLoading: setLoadingState };
};

export default useLoadingHook;
